import React from "react"
import { useNavigate } from "react-router-dom"

const BackButton = () => {
  const navigate = useNavigate()

  const goBack = () => {
    navigate(-1)
  }

  return <i className="bx bx-arrow-back me-1 fs-5 cursor-pointer" onClick={goBack}></i>
}

export default BackButton
